export default "__VITE_ASSET__efc304de__"